module.exports = __webpack_public_path__ + "img/37.01457ba6.png";